export default __webpack_public_path__ + "static/media/icon_dth.d3e7e671.svg";